import { trackClick } from '@/helpers/Analytics';
import clsx from 'clsx';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { CMS } from '@/types/CMS';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import ProductTile from '@/components/ecommerce/ProductTile/ProductTile';
import { itemApi } from '@/queries/item';
import { Item } from '@/api';

export type INavLinkProps = {
    href: string;
    children: string;
    external?: boolean;
    menuItem?: CMS.Global.Menu;
};

const NavLink = (props: INavLinkProps) => {
    const { href, children, external, menuItem } = props;
    const currentRoute = usePathname();
    const [showSubMenu, setShowSubMenu] = useState<boolean>(false);
    const [products, setProducts] = useState<Item[]>([]);
    const pathname = usePathname();

    const showSubMenuFlag = menuItem?.items && menuItem?.items.length > 0 && showSubMenu;

    useEffect(() => {
        if (menuItem?.submenu_items && menuItem.submenu_items.length) {
            itemApi.itemControllerGetBulk(menuItem.submenu_items).then((itemProducts) => {
                setProducts(itemProducts);
                return itemProducts;
            }).catch(() => {
            });
        }
    }, [menuItem?.submenu_items]);

    useEffect(() => setShowSubMenu(false), [pathname]);

    return (
        <div
            className="pb-[29px] pt-[29px]"
            onMouseEnter={() => {
                setShowSubMenu(true);
            }}
            onMouseLeave={() => {
                setShowSubMenu(false);
            }}
        >
            <Link
                onClick={trackClick()}
                href={href}
                target={external ? '_blank' : undefined}
                className={clsx('text-[16px]  hover:text-blue12 px-4  tablet:px-1 capitalize font-[500] flex flex-row justify-center items-center whitespace-nowrap', currentRoute === href
                    ? 'text-blue2'
                    : 'text-grey7')}
            >
                {children}
                {menuItem?.items && menuItem?.items?.length > 0 && <motion.div className="mt-[3px]" animate={{ transform: !showSubMenuFlag ? 'rotate(0deg)' : 'rotate(180deg)' }}><ChevronDownIcon className="w-[18px]" /></motion.div>}
            </Link>
            <AnimatePresence>
                {showSubMenuFlag &&
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 28 }}
                        exit={{ opacity: 0, y: 20 }}
                        className="fixed left-0 right-0 bg-white py-[24px] shadow-lg z-[-10]">
                        <div className="max-w-outer mx-auto flex flex-row px-[12px] gap-[24px]">
                            <div
                                className={clsx('px-[24px]', products && products.length > 0 ? 'grid grid-cols-3 w-1/2' : 'flex flex-wrap gap-4 w-full')}
                                style={{
                                    justifyContent: menuItem.items?.length === 1 ? 'flex-start' : 'flex-start',
                                }}>
                                {menuItem.items?.map((subMenuItem, i) => {
                                    return (
                                        <div key={`subMenuKey${subMenuItem.id}`} className="">
                                            <span className="text-[15px] mb-[15px] text-gray-500 hover:text-blue12 px-4  tablet:px-1 capitalize font-[500] flex flex-row justify-start items-center">
                                                <Link href={subMenuItem.path} target={subMenuItem.external ? '_blank' : undefined}>
                                                    {subMenuItem.title}
                                                </Link>
                                            </span>
                                            <div>
                                                {subMenuItem.items?.map((subSubMenuItem) => {
                                                    return (
                                                        <div key={`subMenu2key${subSubMenuItem.id}`} className="mb-[10px]">
                                                            <span className="text-[12px]  hover:text-blue12 px-4  tablet:px-1 tablet:text-[14px] capitalize font-[500] flex flex-row justify-start items-center ">
                                                                <Link href={subSubMenuItem.path} target={subSubMenuItem.external ? '_blank' : undefined}>
                                                                    {subSubMenuItem.title}
                                                                </Link>
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            {products && products.length > 0 &&
                                <div
                                    className="w-1/2 gap-[16px] flex flex-row justify-end">
                                    {products.map((item, index) => {
                                        const classNameAdditional0 = index === 0 && 'tablet:hidden ';
                                        const classNameAdditional1 = 'tablet:w-1/2';
                                        const classNameAdditional2 = 'tablet:w-1/2';
                                        return !item ? null : (
                                            <div className={clsx('w-1/3 block', classNameAdditional0, classNameAdditional1, classNameAdditional2)} key={item.id}>
                                                <ProductTile fullWidth data={item} />
                                            </div>
                                        );
                                    })}
                                </div>
                            }
                        </div>
                    </motion.div>
                }
            </AnimatePresence>
        </div>
    );
};
export default NavLink;
